/**
 * Distinguishes missing (null/undefined/non-finite) from real 0 —
 * `Number(null) === 0` would otherwise silently fold null into denominators.
 */
export function toFiniteSeriesNumber(v: unknown): number | null {
  if (v === null || v === undefined) return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}
